export default __webpack_public_path__ + "static/media/lotus-dark.17f390b5.svg";